<template>
  <div id="app" v-bind:class="{abgelaufen_blur: hundAnzeigen, portrait:$mq.portrait, noportrait:!$mq.portrait, ios:ios, iphone:iphone, ipad:ipad}">
    <transition name="fade">
      <div class="abgelaufen_meldung pointer" v-if="hundAnzeigen">
        <div class="fullbg_dark"></div>
        <div class="messagebox">
          <img to="/liberoalarm" src="/static/assets/alle/Libero_alarm_ende.png" v-if="showok" v-on:click="showokOff" />
        </div>
        <div class="liberobox">
          <img to="/liberoalarm" src="/static/assets/alle/Libero_alarm.png" />
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div id="drehbildschirm" v-if="$mq.portrait">
        <img class="drehbildschirm" src="/static/assets/alle/Drehbildschirm.jpg" />
      </div>
      <router-view v-if="!$mq.portrait"></router-view>
    </transition>
  </div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */

import Vue from 'vue'
import Router from '@/router/index.js'
import VueAnalytics from 'vue-analytics'
import { bus } from '@/main.js'
import MQ from 'vue-match-media'
Vue.use(MQ)

window.optout = window.localStorage.getItem('optout')

if (window.optout === null) window.optout = false
console.log('window.optout', window.optout)
console.log('window.einverstanden', window.einverstanden)

Vue.use(VueAnalytics, {
  id: 'UA-121933036-1',
  checkDuplicatedScript: true,
  disabled: window.optout,
  router: Router
})

window.abgelaufen = false
// in millisekunden - 1000 = 1 sek, 60000 = 1 min
window.maxzeit = 60000 * 10
window.verweilt = null
window.timerObj = null

window.$ = window.jQuery = require('jquery')

var basePage = {
  width: 1920,
  height: 1080,
  scale: 1,
  scaleX: 1,
  scaleY: 1
}
var $page

export default {
  name: 'App',
  mq: {
    portrait: '(orientation: portrait)',
    landscape: '(orientation: landscape)',
    phone: '(max-width: 768px)',
    tablet: '(max-width: 1024px)',
    desktop: '(min-width: 1024px)'
  },
  data () {
    return {
      abgelaufen: true,
      noAlarm: true,
      hundAnzeigen: false,
      zeit: '',
      muted: false,
      ios: false, 
      ipad: false,
      iphone: false,
      angezeigt: false,
      showok: false
    }
  },
  computed: {
    getHundanzeige () {
      bus.$emit('abgelaufenEvent')
      var self = this
      // eslint-disable-next-line
      setTimeout(function () {
        self.hundAnzeigen = self.getAbgelaufen()
        self.showok = true
      }, 100)
      return this.hundAnzeigen
    }
  },
  watch: {
    abgelaufen: function (oldval, newval) {
      // console.log('abgelaufen watch: ', this.getAbgelaufen())
      this.hundAnzeigen = this.getAbgelaufen()
      this.showok = true
      if (this.hundAnzeigen) {
        window.currentAudio = new Audio('/static/assets/sounds/01_Frontpage/SFX/Timer_abgelaufen_V1_Update.mp3')
        window.currentAudio.muted = window.muted
        window.currentAudio.play()
      }
    },
    showok: function (oldval, newval) {
      console.log('showok: ', this.showok)
    }
  },
  methods: {
    showokOff () {
      bus.$emit('liberoalarm_aus')
      this.showok = false
      window.currentAudio = new Audio('/static/assets/sounds/01_Frontpage/SFX/Timer_abgelaufen_V1_Update.mp3')
      window.currentAudio.muted = window.muted
      window.currentAudio.play()
    },
    aus () {
      this.angezeigt = true
    },
    setMuted (value) {
      this.muted = value
    },
    getMuted () {
      return this.muted
    },
    getAbgelaufen () {
      return window.abgelaufen && !window.noAlarm
    },

    liberoAlarm () {
      // console.log('liberoalarm funktion start')
      window.verweilt = window.localStorage.getItem('verweilt')
      window.maxzeit = window.localStorage.getItem('maxzeit')
      if (window.maxzeit == null) {
        window.localStorage.setItem('maxzeit', 60000)
        window.maxzeit = 60000
      }
      // console.log('verweilt HIER', window.verweilt)
      if (window.verweilt == null) {
        window.verweilt = 0
        console.log('verweilt schreiben')
        // wurde noch nicht geschrieben
        // console.log('verweilt', window.verweilt)
        window.localStorage.setItem('verweilt', window.verweilt)
      } else {
        // immer hochzählen
        window.verweilt = parseInt(window.verweilt) + 1000
        // console.log('verweilt', window.verweilt)
        window.localStorage.setItem('verweilt', window.verweilt)
      }

      if (typeof window.noAlarm === 'undefined') window.noAlarm = false
      this.noAlarm = window.noAlarm
      // console.log('noAlarm: ', window.noAlarm)
      if (!window.noAlarm) {
        if (window.verweilt > window.maxzeit) {
          window.abgelaufen = true
          // console.log('liberoalarm abgelaufen, verweilzeit=', window.verweilt, 'maxzeit=', window.maxzeit, window.maxzeitTimeString)
        } else {
          window.abgelaufen = false
          bus.$emit('updateTimer')

          // console.log('liberoalarm nocht nicht abgelaufen, verweilzeit=', window.verweilt, 'maxzeit=', window.maxzeit, window.maxzeitTimeString)
        }
      }
      this.hundAnzeigen = this.getAbgelaufen()
      this.abgelaufen = this.getAbgelaufen()
      bus.$emit('updateTimer')
      // console.log('liberoAlarm nach bus emit updateTimer')
    },
    scalePages () {
      $page = $('#app')

      setTimeout(function () {
        console.log('scalePages started')
        // var scaleX = 1
        var scaleY = 1

        // var w = this.pageWidth
        // var h = this.pageHeight
        // var w = document.documentElement.clientWidth
        var h = document.documentElement.clientHeight
        // var r = gcd (w, h);
        // var r = w / h
        // console.log('Dimensions = ', w, 'x', h)
        // console.log('Aspect     = ', w / r, ':', h / r)
        //    if (((w/r)> 17) && ((h/r)>11)) {
        // console.log('r', r)
        // if (r > 1.6) {
        //  // console.log('skalieren nach breite')
        //  scaleX = w / basePage.width
        //  // scaleY = maxHeight / basePage.height;
        //  basePage.scaleX = scaleX
        //  basePage.scale = scaleX

        //   leftPosition = (scaleY - 1) * 100 / 2

        //  $page.attr('style', 'transform-origin: bottom left; transform:scale(' + basePage.scale + ');-webkit-transform:scale(' + basePage.scale + '); -ms-transform::scale(' + basePage.scale + ');')
        // } else {
        // console.log('skalieren nach höhe')
        // wird gerendert wenn: verhältnis < 16:10
        // scaleX = maxWidth / basePage.width
        scaleY = h / basePage.height
        // basePage.scaleX = scaleX
        basePage.scaleY = scaleY
        basePage.scale = scaleY
        var leftPosition = (scaleY - 1) * 100 / 2
        if ($('#app').hasClass('portrait')) {
          console.log('portrait mode - KEIN SKALIEREN!!')
          $page.attr('style', '')
        } else {
          console.log('landscape mode - BITTE SKALIEREN!!')
          $page.attr('style', 'transform-origin: top center; transform:scale(' + basePage.scale + ');-webkit-transform:scale(' + basePage.scale + '); -ms-transform::scale(' + basePage.scale + ');  /* left: -' + leftPosition + '%; */ ')
        }
        // }
      }, 150)
    }
  },
  beforeDestroy () {
    // window.removeEventListener('resize', this.scalePages)
  },
  mounted () {
    // this.$nextTick(function() {
    this.ios = /iPad/.test(navigator.userAgent) && !window.MSStream
    this.ipad = /iPad/.test(navigator.userAgent) && !window.MSStream
    this.iphone = /iPhone/.test(navigator.userAgent) && !window.MSStream
    this.$emit('ClickLautsprecher')
    this.$emit('ClickLautsprecher')
    console.log('App.vue mounted gestartet')
    window.noAlarm = true
    var m = window.localStorage.getItem('muted')
    if (m === null) { 
      this.muted = false
      window.localStorage.setItem('muted', this.muted)
    } else if (m === 'true') { this.muted = true } else { this.muted = false }
    console.log('ausgelesen muted: ', this.muted)
    $page = $('#app.noportrait')
    this.scalePages()
    window.addEventListener('resize', this.scalePages)
    // })
    // liberoalarm timer
    window.timerObj = this
    this.liberoAlarm()
    setInterval(function () {
      window.timerObj.liberoAlarm()
    }, 1000)
  }
}
</script>

<style lang="scss">
$FontPathOpenSans: "../node_modules/npm-font-open-sans/fonts";
@import '../node_modules/npm-font-open-sans/open-sans.scss';

body {
  overflow: hidden;
  margin:0; padding: 0;
}

#app {
  position: absolute;
  top: 0;
  left: calc(50% - 960px);
  width: 1920px;
  height: 1080px;
}

#app.portrait {
  width: 100% !important;
  height: auto !important;
  top:0 !important;
  left: 0 !important;
}

.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

/* bounce animation */

.bounce-enter-active {
  animation: bounce-in .5s;
}

.bounce-leave-active {
  animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0)
  }
  50% {
    transform: scale(1.5)
  }
  100% {
    transform: scale(1)
  }
}

/* move animation */

.move-enter-active {
  animation: move-in .5s;
}

.move-leave-active {
  animation: move-in .5s reverse;
}

@keyframes move-in {
  0% {
    width: 0px;
  }
  100% {
    width: 650px;
  }
}

/* firefox bug fix height=0 bei container */

#container {
  height: 100%;
}

/* geschichten pfeile links/rechts */

#container .pfeil_links_big {
  position: absolute;
  left: 1vw;
  top: 30%;
}

#container .pfeil_rechts_big {
  position: absolute;
  right: 1vw;
  top: 30%;
}

@media screen and (max-width: 1280px) {
  .geschichte {
    position: absolute;
    top: 21vh;
    left: 47%;
  }
}

/* tablet */
/* @media only screen and (min-device-width: 1366px) and (max-device-height: 1024px) and (-webkit-min-device-pixel-ratio: 2)  and (orientation: landscape)  { */
  #app.ios { overflow: hidden; left:-20%; }
  #app.ios #container .pfeil_rechts_big {
    right: 13% !important;
  }
  #app.ios #container .pfeil_links_big {
    left: 13% !important;
  }
/* } */
@media screen and (max-width: 1024px) {
  #app.ios { overflow: hidden; left:-44%; }
  #container .pfeil_rechts_big {
    right: 13% !important;
  }
  #container .pfeil_links_big {
    left: 13% !important;
  }
}

.pointer {
  cursor: pointer;
}

.fullscreen_background {
  position: absolute;
  top: -25%;
  left: -25%;
}

/* .fullscreen_background {
  height: 1350px;
  overflow-y: hidden;
} */

/* .abgelaufen_blur #container {  filter: blur(5px); } */

.abgelaufen_meldung {
  position: fixed;
  right: calc(25% - 318px);
  bottom: -7px;
  z-index: 999999;
}

.liberoAlarmSeite .abgelaufen_meldung {
  display: none !important;
}

.liberoAlarmSeite #container {
  filter: blur(0px) !important;
}

.fullbg_dark {
  width: 150%;
  height: 100%;
  position: fixed;
  top: 0;
  left: -25%;
  background-color: #000000;
  opacity: 0.7;
}

.messagebox {
  position: fixed;
  top: 30%;
  left: calc(50% - 300px);
}

.liberobox {
  position: fixed;
  bottom: 0%;
  right: 0%;
}

.drehbildschirm {
  width: 100% !important;
  height: auto !important;
  z-index: 99999;
}

.ps>.ps__scrollbar-y-rail>.ps__scrollbar-y {
    position: absolute;
    background-color: #ac8a69 !important;
    border-radius: 6px;
    transition: background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;
    right: 2px;
    width: 6px;
}
.ps:hover>.ps__scrollbar-y-rail:hover>.ps__scrollbar-y {
    background-color: #ac8a69 !important;
}
.error.message {display:none;}
</style>



// WEBPACK FOOTER //
// src/App.vue